import GenerationTextArea from './GenerationTextArea'

export default  GenerationTextArea